import { format } from 'date-fns';

export const formatUSDate = (date: string | Date): string => {
  const d = new Date(date);
  return d.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit'
  });
};

export const formatAppointmentDate = (date: string | Date): string => {
  const d = new Date(date);
  return format(d, 'dd MMM yyyy');
};